import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const OverlayContainer = styled.div`
  display: ${props => (props.visible ? 'flex' : 'none')};
  position: absolute;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99999999999;
  opacity: .75;
  color: white;
  background-color: black;
  width: 100%;
  height: 100%;
`;

class FullScreenOverlay extends PureComponent {
  render() {
    return (
      <OverlayContainer visible={this.props.visible}>
        { this.props.children }
      </OverlayContainer>
    );
  }
}

FullScreenOverlay.defaultProps = {
  children: null
};

FullScreenOverlay.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string
  ]),
  visible: PropTypes.bool.isRequired
};

export default FullScreenOverlay;



// WEBPACK FOOTER //
// ./app/components/FullScreenOverlay.js